import { render, staticRenderFns } from "./TagCell.vue?vue&type=template&id=06876d48&functional=true&"
import script from "./TagCell.vue?vue&type=script&lang=js&"
export * from "./TagCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports